exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field .input-label{font-size:1.15rem}.field .input-field{margin-bottom:.75rem}", ""]);

// exports
